import ENDPOINTS from '../../../constants/apiEndPoints';
import {axiosInstance} from '../../axiosInstance';

export type DepartmentQueryParams = {
  sortBy?: string;
  sortOrder?: string;
  clientId?: string | string[];
  branchId?: string | string[];
};

export const handleGetAllDepartmentsService = async (
  params?: DepartmentQueryParams,
) => {
  const response = await axiosInstance.get(ENDPOINTS.GET_CREATE_DEPARTMENT, {
    params: {sortBy: 'name', sortOrder: 'asc', ...params},
  });
  return response?.data?.data;
};
